import axios from "axios";
import instance, { apiUrl } from "./axios.config";

const getuserShips = (user_id) =>
    instance.get(`/owner/user/${user_id}`);


const getuserprofile = () =>
    instance.get(`/ships/getuserinfo`);


const updateuserProfile = (payload) =>
    instance.put(`/ships/changeprofile`, payload);

const checkuserexist = async(payload) =>
    await axios.post(
        `${apiUrl}/auth/checkuserexist`,
        payload
      );
      const forgetpassword = async(payload) =>
    await axios.post(
        `${apiUrl}/auth/forgetpassword`,
        payload
      );
 
 

const userService = {checkuserexist,
    getuserShips, getuserprofile, updateuserProfile,forgetpassword
}
export default userService;


